export const CREATE_USER_RECAPTCHA_SITE_KEY = '6LdG6kgjAAAAALIV4fJh8mwHz9PXowXDWeTVBAuY';
